import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-upload-image',
  templateUrl: './modal-upload-image.component.html',
  styleUrls: ['./modal-upload-image.component.scss', '../modal-admin-area/modal-admin-area.component.scss']
})
export class ModalUploadImageComponent implements OnInit {

  imageChangedEvent: any = '';
  croppedImage: any = '';
  uploadingImage = false;
  loadingImage: boolean = false;
  @Output() close = new EventEmitter<string>();

  constructor(
    private toastService: ToastrService,
    private sanitizer: DomSanitizer
  ) {

  }

  ngOnInit(): void {
      
  }

  showUploadImage() {
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.loadingImage = true;
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  uploadImage(){
    this.close.emit(this.croppedImage);
  }
}
